import axios from 'axios'

export default {
    register (token, data) {
        return axios.post(`/api/register/${token}`, data)
    },
    csrfCookie () {
        return axios.get('/sanctum/csrf-cookie')
    },
    login (data) {
        return axios.post('/api/login', data)
    },
    logout () {
        return axios.post('/api/logout')
    },
    async sendResetLink (data) {
        await this.csrfCookie()
        return axios.post('/api/password/email', data)
    },
    async updatePassword (data) {
        await this.csrfCookie()
        return axios.post('/api/password/reset', data)
    },
    socialLogin (provider, response) {
        return axios.post(`/api/auth/${provider}`, response)
    }
}